import React from 'react';
import { connect } from 'react-redux';
import UserCell from './UserCell';

const mapStateToProps = ({
  applicantsReducer,
}) => {
  return {
    applicantsDictionary: applicantsReducer.applicants.data,
  };
};

const UserCellContainer = connect(
  mapStateToProps,
)((props) => {
  const {
    applicantsDictionary,
  } = props;

  return <UserCell
    applicantsDictionary = {applicantsDictionary}
    {...props}
  /> 
});

export default UserCellContainer;